var _excluded = ["visible", "onClose"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import ReactDOM from "react-dom";
import React from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import { useUniqueID } from "@xo-union/react-unique-id";
import Snackbar from "../Snackbar/index.js";
import { useSnackbarQueue, useSnackbarQueueContext } from "../SnackbarContext/index.js";
var DEFAULT_AUTO_DISMISS_MS = 20000;
var GLOBAL_CONTAINER_ID = 'Union__global-snackbar-container';
var ControlledSnackbar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    containerElement = _React$useState2[0],
    setContainerElement = _React$useState2[1];
  var fallbackQueue = useSnackbarQueue();
  var contextQueue = useSnackbarQueueContext();
  var queue = contextQueue || fallbackQueue;
  var id = useUniqueID();
  var visible = props.visible,
    onClose = props.onClose,
    snackbarProps = _objectWithoutProperties(props, _excluded);
  React.useImperativeHandle(ref, function () {
    var api = {
      showAndDismiss: function showAndDismiss(_ref) {
        var data = _ref.data,
          _ref$dismissTimeout = _ref.dismissTimeout,
          dismissTimeout = _ref$dismissTimeout === void 0 ? DEFAULT_AUTO_DISMISS_MS : _ref$dismissTimeout;
        queue.dismissAll(id);
        queue.push({
          id: id,
          data: data,
          dismissTimeout: dismissTimeout
        });
      },
      dismiss: function dismiss() {
        queue.dismissAll(id);
      },
      isVisible: function isVisible() {
        return queue.isVisible(id);
      }
    };
    return api;
  }, [queue, id]);
  React.useEffect(function () {
    var container = document.getElementById(GLOBAL_CONTAINER_ID) || document.createElement('div');
    container.id = GLOBAL_CONTAINER_ID;
    document.body.appendChild(container);
    setContainerElement(container);
  }, []);
  var snackbar = /*#__PURE__*/React.createElement(Snackbar, _extends({
    visible: queue.isVisible(id),
    onClose: function onClose() {
      queue.dismissAll(id);
      props.onClose();
    }
  }, snackbarProps), typeof snackbarProps.children === 'function' ? snackbarProps.children(queue.getData(id)) : queue.getData(id));
  if (snackbarProps.fixedToRelative) {
    return snackbar;
  }
  if (containerElement) {
    return /*#__PURE__*/ReactDOM.createPortal(snackbar, containerElement);
  }
  return null;
});
ControlledSnackbar.defaultProps = {
  fixedToRelative: false,
  onClose: noop
};
ControlledSnackbar.propTypes = {
  /**
   * Contents of snackbar
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * Whether or not to position the snackbar within a relative.
   * This use is discouraged except for a few scenarios like the sidebar. This
   * is only supported if the parent container is at the bottom of the viewport.
   */
  fixedToRelative: PropTypes.bool,
  /**
   * Called when the close button is clicked
   */
  onClose: PropTypes.func,
  /**
   * Should the snackbar be visible
   */
  visible: PropTypes.bool,
  /**
   * ID of the snackbar component
   */
  id: PropTypes.string
};
export default ControlledSnackbar;